import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireforranjangaonmahaganpati() {



const cardData =
{
  keyword: 'Bus Hire for Ranjangaon Mahaganpati',
  heading: 'Sanavi Travels: Bus Hire for Ranjangaon Mahaganpati',
  headingDescription: 'Sanavi Travels offers trusted and well-organized bus hire for Ranjangaon Mahaganpati, ideal for pilgrims, families, corporate groups, senior citizens, wedding guests, and picnic travelers seeking a smooth, safe, and spiritually fulfilling group journey.',

  top: 'Top Experiences & Places to Visit at Ranjangaon Mahaganpati',

  topPlaces: [
    {
      title: 'Ranjangaon Mahaganpati Temple Darshan',
      description: 'Ranjangaon Mahaganpati is one of the eight sacred Ashtavinayak temples of Lord Ganesha and holds immense spiritual significance for devotees across Maharashtra and India. Hiring a bus for Ranjangaon Mahaganpati allows large groups to travel together in a disciplined and peaceful manner, ensuring timely arrival for darshan without the stress of coordinating multiple vehicles. Group bus travel is especially beneficial for senior citizens, devotees, and families, offering comfortable seating, smooth rides, and reduced fatigue. The journey itself becomes a devotional experience filled with bhajans, prayers, and shared spiritual moments.'
    },
    {
      title: 'Ashtavinayak Pilgrimage Circuit',
      description: 'Many devotees include Ranjangaon Mahaganpati as part of the complete Ashtavinayak yatra. A hired bus makes it easy to follow a planned pilgrimage route, maintain proper timing, and manage group movement efficiently. Bus travel ensures everyone stays together, avoids route confusion, and enjoys a calm, organized pilgrimage experience.'
    },
    {
      title: 'Family Spiritual Getaways',
      description: 'Families often visit Ranjangaon Mahaganpati for blessings during important life events such as weddings, new beginnings, or festivals. Bus hire supports multi-generational travel, providing safety and comfort for elders and children alike while eliminating travel stress.'
    },
    {
      title: 'Corporate & Group Religious Tours',
      description: 'Corporate groups and organizations frequently plan spiritual outings for team bonding and positive experiences. Bus hire ensures punctual departures, professional travel arrangements, and a relaxed environment suitable for group coordination.'
    },
    {
      title: 'Weekend Pilgrimage from Pune & Mumbai',
      description: 'Ranjangaon Mahaganpati is a popular weekend pilgrimage destination. Group bus travel reduces road fatigue, allows shared rest breaks, and makes the journey more enjoyable compared to driving separate vehicles.'
    },
    {
      title: 'School & Educational Visits',
      description: 'Educational institutions organize temple visits to teach cultural values and traditions. Bus hire enables teachers to supervise students easily and ensures disciplined, safe travel throughout the trip.'
    },
    {
      title: 'Wedding & Family Function Travel',
      description: 'Families often visit Ranjangaon Mahaganpati before weddings or auspicious ceremonies. Buses simplify guest transportation and ensure everyone reaches the temple on time.'
    },
    {
      title: 'Peaceful Rural Surroundings',
      description: 'The temple is surrounded by calm village landscapes that enhance the spiritual experience. Group bus travel allows travelers to enjoy the serene environment together without travel-related distractions.'
    },
    {
      title: 'Festival & Special Occasion Visits',
      description: 'During Ganesh Chaturthi and other festivals, Ranjangaon attracts large crowds. Bus rentals help manage group movement efficiently during peak times.'
    },
    {
      title: 'One-Day & Multi-Day Pilgrimage Plans',
      description: 'Bus hire supports flexible itineraries, whether it’s a one-day darshan trip or a multi-day Ashtavinayak tour including nearby temples.'
    }
  ],

  services: [
    {
      name: 'Bus Hire for Ranjangaon Mahaganpati',
      description: 'Sanavi Travels provides dedicated bus hire services for Ranjangaon Mahaganpati with a strong focus on safety, comfort, and devotional travel needs. Our buses are ideal for pilgrims, families, senior citizens, corporate groups, and large religious tours. Spacious seating, smooth suspension, experienced drivers, and reliable scheduling ensure a peaceful and well-coordinated journey.'
    },
    {
      name: 'AC Bus for Ranjangaon Mahaganpati',
      description: 'AC buses offer enhanced comfort during long travel hours, especially helpful for elderly devotees and families seeking a relaxed journey.'
    },
    {
      name: 'Non AC Bus Hire Ranjangaon Mahaganpati',
      description: 'Non-AC buses provide a budget-friendly option for large pilgrim groups without compromising safety or seating comfort.'
    },
    {
      name: 'Luxury Bus Hire Ranjangaon Mahaganpati',
      description: 'Luxury buses with premium interiors are suitable for VIP pilgrims, corporate spiritual tours, and special occasions.'
    },
    {
      name: 'Mini Bus on Rent Ranjangaon Mahaganpati',
      description: 'Mini buses are perfect for smaller family groups, offering flexibility and easy maneuverability.'
    },
    {
      name: '32 Seater Bus Ranjangaon Mahaganpati',
      description: '32 seater buses are ideal for medium-sized pilgrim groups, schools, and corporate teams.'
    },
    {
      name: '35 Seater Bus Hire Ranjangaon Mahaganpati',
      description: '35 seater buses accommodate large groups comfortably, making them ideal for festival and temple tours.'
    },
    {
      name: 'Bus for Family Ranjangaon Mahaganpati',
      description: 'Family-friendly buses ensure safe, calm, and comfortable travel for all age groups.'
    },
    {
      name: 'Bus for Corporate Ranjangaon Mahaganpati',
      description: 'Corporate bus services support organized spiritual outings with punctual schedules and professional service.'
    },
    {
      name: 'Affordable Bus Rental Ranjangaon Mahaganpati',
      description: 'Affordable pricing plans help groups plan pilgrimages within budget while maintaining service quality.'
    },
    {
      name: 'Best Bus Service Ranjangaon Mahaganpati',
      description: 'Sanavi Travels is known for reliability, experienced drivers, and consistent customer satisfaction.'
    },
    {
      name: 'Bus with Driver Ranjangaon Mahaganpati',
      description: 'All buses come with trained drivers familiar with pilgrimage routes and crowd conditions.'
    },
    {
      name: 'Bus for Wedding Ranjangaon Mahaganpati',
      description: 'Wedding-related temple visits are made easy with organized guest transportation.'
    },
    {
      name: 'Bus for Picnic Ranjangaon Mahaganpati',
      description: 'Picnic buses support relaxed group outings combined with spiritual visits.'
    },
    {
      name: 'Outstation Bus Ranjangaon Mahaganpati',
      description: 'Outstation-ready buses ensure safe and comfortable long-distance travel.'
    }
  ],

  tableData: [
    ['AC Bus', 'Non AC Bus'],
    ['Mini Bus', 'Luxury Bus'],
    ['Family Trip', 'Corporate Trip'],
    ['Pilgrimage', 'Picnic'],
    ['Affordable', 'Premium Options']
  ],

  whychoose: [
    {
      WhyChooseheading: 'Experienced Pilgrimage Route Drivers',
      WhyChoosedescription: 'Our drivers are well-versed with temple routes, peak crowd timings, and safe driving practices.'
    },
    {
      WhyChooseheading: 'Comfortable & Clean Buses',
      WhyChoosedescription: 'All buses are regularly maintained and cleaned to ensure a peaceful travel experience.'
    },
    {
      WhyChooseheading: 'Multiple Seating Options',
      WhyChoosedescription: 'We offer mini buses, 32 seater, and 35 seater buses to suit every group size.'
    },
    {
      WhyChooseheading: 'Transparent Pricing',
      WhyChoosedescription: 'Clear pricing with no hidden charges ensures trust and clarity.'
    },
    {
      WhyChooseheading: 'Safe & Sanitized Vehicles',
      WhyChoosedescription: 'Vehicles are sanitized before every trip to ensure hygiene and safety.'
    },
    {
      WhyChooseheading: 'Flexible Pickup & Timing',
      WhyChoosedescription: 'Pickup points and schedules can be customized as per group needs.'
    },
    {
      WhyChooseheading: 'Ideal for Ashtavinayak Tours',
      WhyChoosedescription: 'Specially designed services for multi-temple pilgrimage routes.'
    },
    {
      WhyChooseheading: '24/7 Customer Support',
      WhyChoosedescription: 'Dedicated support from booking to journey completion.'
    }
  ]
};

const faqData = [
  { question: 'Do you provide bus hire for Ranjangaon Mahaganpati?', answer: 'Yes, we provide AC and Non-AC buses for Ranjangaon Mahaganpati temple visits.' },
  { question: 'Is this service suitable for senior citizens?', answer: 'Yes, our buses are comfortable and ideal for elderly devotees.' },
  { question: 'Can corporate groups book buses?', answer: 'Yes, corporate spiritual tours are regularly arranged.' },
  { question: 'Are drivers experienced with temple routes?', answer: 'Yes, our drivers are familiar with pilgrimage routes and crowd conditions.' },
  { question: 'Are AC buses available?', answer: 'Yes, AC buses are available for added comfort.' },
  { question: 'Is advance booking required?', answer: 'Advance booking is recommended during festivals and weekends.' },
  { question: 'Can pickup points be customized?', answer: 'Yes, pickup locations can be customized.' },
  { question: 'Are buses sanitized?', answer: 'Yes, buses are cleaned and sanitized before every trip.' },
  { question: 'Do you offer affordable pricing?', answer: 'Yes, competitive and transparent pricing is available.' },
  { question: 'Is customer support available during the trip?', answer: 'Yes, 24/7 customer support is provided.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ashok Kulkarni',
    feedback: 'Our family group hired a bus from Sanavi Travels for Ranjangaon Mahaganpati darshan. The bus was very clean and comfortable, and the driver was polite and experienced. Traveling together made the pilgrimage peaceful and well organized. Excellent service overall.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sunita Patil',
    feedback: 'We booked a bus for an Ashtavinayak trip including Ranjangaon Mahaganpati. Sanavi Travels managed everything perfectly. The journey was smooth, punctual, and stress-free. Highly recommended for group temple visits.',
    rating: 5
  }
];

































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];






const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for Ranjangaon Mahaganpati - Sanavi Travels",
  "description": "Sanavi Travels offers bus hire services for Ranjangaon Mahaganpati Darshan, including AC and Non-AC buses, luxury buses, 32-seater, 35-seater, and mini bus options. Ideal for family trips, corporate travel, weddings, picnics, and outstation journeys with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};









  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus Hire for Ranjangaon Mahaganpati | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book buses for Ranjangaon Mahaganpati Darshan with Sanavi Travels. AC & Non-AC buses, luxury buses, 32-seater, 35-seater, and mini bus options for family trips, corporate travel, weddings, picnics, and outstation journeys with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/301.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireforranjangaonmahaganpati;